'use client'

import { ChakraProvider, defaultSystem } from '@chakra-ui/react'
import { ColorModeProvider } from './color-mode'

export function Provider(props) {
  return (
    <ChakraProvider value={props.theme || defaultSystem}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  )
}
